import Setting from "../models/Setting";
export const SettingMixin = {
  data() {
    return {
      setting: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Setting({
        title: null,
        option: null
      })
    }
  }
}
